import { apiSlice } from "api/apiSlice";

import {
    createSelector,
    createEntityAdapter,
} from "@reduxjs/toolkit";

const sizeFormatter = Intl.NumberFormat('en', { notation: 'compact' });
const categoryAdapter = createEntityAdapter({
    selectId: (itemList) => itemList.id,
    sortComparer: (a, b) => b.id - a.id
})

/* eslint-disable */
const sanitizedMenu = (cate_gory, navBar) =>{
    if( cate_gory.related_categories?.length > 0 ) {
        if (cate_gory.level === 0 && cate_gory.related_categories?.length > 0){
            cate_gory.dropdown = true;
        }
        const sanitizedSubCat = cate_gory.related_categories.map( cate => sanitizedMenu(cate,navBar));
        !navBar ? cate_gory.related_categories = sanitizedSubCat : cate_gory.collapse = sanitizedSubCat;    // collapse for the menu bar
    }

    cate_gory.related_categories?.length === 0 ? cate_gory.route = cate_gory.category : null;

    if(cate_gory.level === undefined) { 
        cate_gory.icon = "favorite" ;
        if(cate_gory.related_categories?.length > 0){
            cate_gory.columns= 4;
            cate_gory.rowsPerColumn= 2;
        } 
    }
    // remove related_categories add this for the menu bar
    const{ createdAt, updatedAt, statistics, __v, provider, active, level,parent, ...rest} = cate_gory; 
    return rest;
}
const initialState = categoryAdapter.getInitialState({
    categoriesDetails : {
        page: 0,
        filters: {},
        categoriesPerpage: 20,
        total_results: 0
    },
    listCategories : [],
    status : 'idle', // loading | succeeded | failed
    error : null
})

export const categoryApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCategory: builder.query({
            query: params => ({ url: `categories`, params }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedCategory = responseData.categories.map(category => {
                    /* eslint-disable */
                    const newcategory = category;
                    newcategory.active = Boolean(category.active === 1);
                    newcategory.quantity = sizeFormatter.format(Number(category.statistics?.quantity) - Number(category.statistics?.sold))
                    const per100 = Number( 100 - (category.statistics?.sold  * 100 / category.statistics.quantity ).toFixed());
                    newcategory.percent = !isNaN(per100) ? per100 : 0;
                    return newcategory
                });
                initialState.categoriesDetails = {
                    ...initialState.categoriesDetails,
                        page: responseData.page,
                        filters: responseData.filters ,
                        categoriesPerpage: responseData.categoriesPerpage,
                        total_results: responseData.total_results
                }
                responseData.parent && loadedCategory.push({name : 'No parent',parent:'/',category:'/', id:0, quantity : 0,statistics:{quantity:0 ,sold:0}});
                return categoryAdapter.setAll(initialState, loadedCategory)
            },
            /* eslint-disable */
            providesTags: (result, error, id) => // [{ type: 'Category', arg }]
             {
                /* eslint-disable */
                if (result?.ids) {
                    return [
                        { type: 'Category', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Category', id }))
                    ]
                } else return [{ type: 'Category', id: 'LIST' }]
            }
        }),
        
        getUserCategory: builder.query({
            query: (id) => ({ url: `userCategory/${id}` }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedCategory = responseData;
                newcategory.active = Boolean(responseData.active === 1);
                return loadedCategory
            },
            /* eslint-disable */
            providesTags: (result, error, id) => [{ type: 'Category', id }],
        }),
        getParentCategories: builder.query({
            query: params => ({ url: `category-menu`, params }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                
                const loadedCategory = Array.isArray(responseData.categoryList) ? responseData.categoryList.map(category => {
                    /* eslint-disable */
                    const newcategory = category;
                    newcategory.active = Boolean(category.active === 1);
                    if( responseData.tree )  return sanitizedMenu(newcategory, responseData.navBar); 
                    return newcategory;
                }) : [];
                return categoryAdapter.setAll(initialState, loadedCategory)
            },
            
            /* eslint-disable */
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Category', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Category', id }))
                    ]
                } else return [{ type: 'Category', id: 'LIST' }]
            }
        }),
        addNewCategory: builder.mutation({
            query: initialCategoryData => ({
                url: '/category',
                method: 'POST',
                body: {
                    ...initialCategoryData,
                }
            }),
            invalidatesTags: [
                { type: 'Category', id: "LIST" }
            ]
        }),
        updateCategory: builder.mutation({
            query: initialCategoryData => ({
                url: '/category',
                method: 'PATCH',
                body: {
                    ...initialCategoryData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Category', id: arg.id }
            ]
        }),
        updateCategoryPhoto: builder.mutation({
            query: initialCategoryData => ({
                url: '/category/upload',
                method: 'POST',
                body: initialCategoryData,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Category', id: arg.id }
            ]
        }),
        deleteCategory: builder.mutation({
            query: ({ id }) => ({
                url: `/category`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Category', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetCategoryQuery,
    useGetUserCategoryQuery,
    useGetParentCategoriesQuery,
    useAddNewCategoryMutation,
    useUpdateCategoryMutation,
    useUpdateCategoryPhotoMutation,
    useDeleteCategoryMutation,
} = categoryApiSlice

// returns the query result object
export const selectCategoryResult = categoryApiSlice.endpoints.getCategory.select()

// creates memoized selector
const selectCategoryData = createSelector(
    selectCategoryResult,
    categoryResult => categoryResult.data // normalized state object with ids & entities
)
//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllcategories,
    selectById: selectCategoryById,
    selectIds: selectCategoryIds
    // Pass in a selector that returns the category slice of state
} = categoryAdapter.getSelectors(state => selectCategoryData(state) ?? initialState)

export const selectCategoryByUser = createSelector(
    [selectAllcategories,(state, userId) => userId],
    (categorys, userId) => categorys.find(category => category.userId === userId)
);
